/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 *
 * Design tokens — Typography
 * Source of truth: Figma Design System
 *   - Typography Primary (node 1319:4) — Hanken Grotesk
 *   - Typography Code (node 1320:1616) — SF Mono
 *
 * Weights used: Regular (400), SemiBold (600)
 */

export const fontFamily = "'Hanken Grotesk', sans-serif";
export const codeFontFamily = "'SF Mono', 'SFMono-Regular', 'Menlo', 'Monaco', 'Consolas', monospace";

export const fontWeights = {
  regular: 400,
  semibold: 600,
} as const;

// ---------------------------------------------------------------------------
// Headers
// ---------------------------------------------------------------------------
export const headers = {
  h1: { fontSize: '24px', lineHeight: '32px' },
  h2: { fontSize: '20px', lineHeight: '26px' },
  h3: { fontSize: '18px', lineHeight: '24px' },
  h4: { fontSize: '16px', lineHeight: '22px' },
} as const;

// ---------------------------------------------------------------------------
// Content / Body
// ---------------------------------------------------------------------------
export const content = {
  b1: { fontSize: '14px', lineHeight: 'normal' },
  b2: { fontSize: '12px', lineHeight: 'normal' },
} as const;

// ---------------------------------------------------------------------------
// Code (SF Mono)
// ---------------------------------------------------------------------------
export const code = {
  c1: { fontSize: '14px', lineHeight: '18px' },
  c2: { fontSize: '12px', lineHeight: 'normal' },
} as const;

// ---------------------------------------------------------------------------
// Button-specific (kept for backward compat with Button component)
// ---------------------------------------------------------------------------
export const buttonTypography = {
  large: {
    fontSize: headers.h4.fontSize,
    fontWeight: fontWeights.semibold,
    lineHeight: headers.h4.lineHeight,
  },
  medium: {
    fontSize: content.b1.fontSize,
    fontWeight: fontWeights.semibold,
    lineHeight: '100%',
  },
} as const;
